import Toursimg from "../../../assets/images/Tours-img.svg";
import Toursicon from "../../../assets/images/Tours-icon.svg";
import Star from "../../../assets/images/star.svg";
import ToursCard from "./ToursCard";
import { useEffect, useRef, useState } from "react";
import CustomDrawing from "./CustomDrawing";
import { useSelectedTours } from "../../../contexts/SelectedToursContext";
import Companies from "../../../components/Companies";
import Modal2 from "../../../components/Modal2";
import { createPortal } from "react-dom";
import toast from "react-hot-toast";
import CenteredToast from "../../../components/CenteredToast";

// const showCenteredToast = (message) => {
//   toast.custom(
//     (t) => (
//       <div
//         className={`leap-bg-white leap-border leap-border-gray-300 leap-rounded-xl leap-shadow-lg leap-p-6 leap-text-black leap-font-bold leap-text-xl ${
//           t.visible ? "animate-enter" : "animate-leave"
//         }`}
//         style={{
//           position: "fixed",
//           top: "50%",
//           left: "50%",
//           transform: "translateX(-50%)",
//           zIndex: 9999,
//           width: "350px",
//           textAlign: "center",
//           pointerEvents: "auto", // Enable interaction if needed
//         }}
//       >
//         {message}
//       </div>
//     ),
//     { duration: 4000 } // Automatically hide after 4 seconds
//   );
// };

function Tours({
  isModal = false,
  tourData,
  isModals = false,
  bookings,
  selectedTours,
  setSelectedTours,
}) {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [isClosable, setIsClosable] = useState(false);
  const [tourDataState, setTourDataState] = useState(tourData);
  const [marginBtn, setMarginBtn] = useState();

  // const [selectedTours, setSelectedTours] = useState([]);
  const imgRef = useRef(null);
  const [imgCoordinates, setImgCoordinates] = useState({
    width: 0,
    left: 0,
    bottom: 0,
  });
  const [numLines, setNumLines] = useState(tourData?.length);

  const updateCoordinates = () => {
    if (imgRef.current) {
      const rect = imgRef.current.getBoundingClientRect();
      setImgCoordinates({
        top: isModal ? rect.top : rect.top + window.scrollY,
        left: isModal ? rect.left : rect.left + window.scrollX,
        right: isModal ? rect.right : rect.right + window.scrollX,
        bottom: isModal ? rect.bottom : rect.bottom + window.scrollY,
        width: rect.width || 0,
        height: rect.height,
      });
    }
  };

  useEffect(() => {
    updateCoordinates();
    window.addEventListener("resize", updateCoordinates);

    const observer = new ResizeObserver(updateCoordinates);
    if (imgRef.current) observer.observe(imgRef.current);
    setNumLines(tourData?.length - 2);

    return () => {
      window.removeEventListener("resize", updateCoordinates);
      if (imgRef.current) observer.disconnect();
    };
  }, [imgRef]);

  const getMaxTours = (data) =>
    Math.max(...data?.map((group) => group.tours?.length));
  const maxTours = getMaxTours(tourData);

  const isLargeScreen = window.innerWidth >= 750;
  const isXLargeScreen = window.innerWidth >= 1280;
  const is2XLargeScreen = window.innerWidth >= 1900;
  const screenWidth = window.innerWidth;

  useEffect(() => {
    const marginBottom = isModal
      ? maxTours > 2
        ? (maxTours - 2) * (isLargeScreen ? 60 : 98)
        : 320
      : maxTours > 2
        ? (maxTours - 2) *
          (screenWidth > 1900
            ? 120
            : screenWidth >= 750 && screenWidth <= 1500
              ? 380
              : 210)
        : 300;
    setMarginBtn(marginBottom);
  }, [screenWidth]);

  const handleTourClick = (Id) => {
    const { title, time, category } = Id;
    if (Id.booked) return;

    setTourDataState((prevTourDataState) => {
      return prevTourDataState?.map((group) => {
        if (group.group === category) {
          return {
            ...group,
            tours: group.tours?.map((tour) =>
              tour?.tour === title && tour.time === time
                ? { ...tour, selected: !tour.selected }
                : tour
            ),
          };
        }
        return group;
      });
    });

    const bookedServicesStartTime = tourData?.flatMap((group) =>
      group.tours
        .filter((tour) => tour?.booked === 1)
        .map((tour) => tour?.startTime)
    );
    const bookedServicesEndTime = tourData?.flatMap((group) =>
      group.tours
        .filter((tour) => tour?.booked === 1)
        .map((tour) => tour?.endTime)
    );

    const bookedServiceIds = tourData?.flatMap((group) =>
      group.tours
        .filter((tour) => tour?.booked === 1)
        .map((tour) => tour?.tourId)
    );
    // Convert time strings to Date objects for accurate comparison
    const parseTime = (timeStr) => new Date(`1970-01-01T${timeStr}Z`);
    const newStart = parseTime(Id.startTime);
    const newEnd = parseTime(Id.endTime);

    // ✅ Prevent selecting tours that overlap in time (even by 1 minute)
    const isTimeOverlapping = bookedServicesStartTime?.some(
      (startTime, index) => {
        const bookedStart = parseTime(startTime);
        const bookedEnd = parseTime(bookedServicesEndTime[index]);

        return newStart < bookedEnd && newEnd > bookedStart;
      }
    );

    if (bookedServiceIds.includes(Id.tourId)) {
      setToastMessage(
        "You cannot book more than one appointment in the same category. Please cancel your current booking first, then proceed with the new one.!"
      );
      setShowToast(true);
      setIsClosable(true);
      return;
    }
    if (isTimeOverlapping) {
      setToastMessage("Time overlaps with an existing booking!");
      setShowToast(true);
      setIsClosable(false);
      return;
    }

    setSelectedTours((prevSelectedTours) => {
      // ✅ Prevent selecting booked tours
      if (bookedServiceIds.includes(Id.tourId)) {
        return prevSelectedTours; // Return without changes
      }
      if (isTimeOverlapping) {
        return prevSelectedTours; // Return without changes
      }

      const tourIndex = prevSelectedTours?.findIndex(
        (selectedTour) => selectedTour.tourId === Id.tourId
      );
      console.log("tourIndex:", tourIndex);

      if (tourIndex >= 0) {
        // If the tour is already selected, remove it s
        return prevSelectedTours?.filter(
          (selectedTour) => selectedTour.tourId !== Id.tourId
        );
      } else {
        // ✅ Remove overlapping tours from prevSelectedTours
        const nonOverlappingTours = prevSelectedTours?.filter(
          (existingTour) => {
            const existingStart = parseTime(existingTour.startTime);
            const existingEnd = parseTime(existingTour.endTime);

            return !(newStart < existingEnd && newEnd > existingStart); // Keep only non-overlapping tours
          }
        );

        // ✅ Add the new tour to the selection
        return [...nonOverlappingTours, Id];
      }
    });
  };

  const [isCodeModalOpen, setIsCodeModalOpen] = useState(false);
  const openCodeModal = () => setIsCodeModalOpen(true);
  const closeCodeModal = () => setIsCodeModalOpen(false);
  const [getTourId, setGetTourId] = useState();

  return (
    <>
      {showToast && (
        <CenteredToast
          message={toastMessage}
          onClose={() => setShowToast(false)}
          isClosable={isClosable}
        />
      )}

      {createPortal(
        <Modal2 isOpen={isCodeModalOpen} closeModal={closeCodeModal}>
          <Companies
            closeCodeModal={closeCodeModal}
            getTourId={getTourId}
            openCodeModal={openCodeModal}
          />
        </Modal2>,
        document.body
      )}

      <div>
        <div>
          <div className={`leap-hidden lg:leap-block`}>
            <CustomDrawing ref={imgRef} numLines={numLines} />
          </div>
        </div>
        <div
          className={`leap-inset-0 leap-flex leap-justify-center leap-gap-6 leap-mt-6`}
          style={{ marginBtn: `${marginBtn}px` }}
        >
          {tourData?.map((tourGroup, index) => {
            const leftPosition =
              tourData.length > 1
                ? (imgCoordinates.width / (tourData.length - 1)) * index
                : imgCoordinates.width / 2;

            return (
              <div
                key={index}
                className="md:leap-absolute leap-mt-4"
                style={{
                  left:
                    isLargeScreen && leftPosition + (imgCoordinates.left || 0),
                  top: (isLargeScreen && imgCoordinates.bottom) || 0,
                  transform: isLargeScreen && `translate(-50%)`,
                }}
              >
                <div
                  style={{
                    transform: isModal && "scale(0.7) translateY(-10%)",
                  }}
                >
                  <ToursCard
                    icon={Toursicon}
                    title={tourGroup.group}
                    gradientBackground="linear-gradient(180deg, #8547F6 0%, #BC98FF 100%)"
                    conicBackground="linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),conic-gradient(from 181.06deg at 50% 50%, rgba(71, 47, 140, 0.4) 0deg, rgba(0, 0, 0, 0) 172.66deg, #4a358268 281.25deg, rgba(71, 47, 140, 0.4) 360deg)"
                    starIcon={Star}
                    openCodeModal={openCodeModal}
                    setGetTourId={setGetTourId}
                    tours={tourGroup.tours}
                    selectedTours={selectedTours}
                    handleTourClick={(Id) => handleTourClick(Id)} // Pass group and tour index
                    index={index}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default Tours;
